/**
 * 整数値入力の共通関数
 * @param val 入力後の値
 * @param min 最小値(マイナス値を除外する場合は0を入れる、設定しない場合はundefined)
 * @param max 最大値
 * @returns
 */
export const formatInteger = (
  val: string,
  min?: number,
  max?: number,
): string | undefined => {
  if (val === "") {
    // 空白の場合は処理を挟まず返す
    return val;
  }

  if (!val.match(/^\d+$/)) {
    // 整数以外の場合は入力を無効化
    return;
  }

  const num = Number(val);
  if ((max !== undefined && num > max) || (min !== undefined && num < min)) {
    // 最大値、最小値の範囲から外れる場合は入力を無効化
    return;
  }
  return String(num);
};

/**
 * 整数文字列入力の共通関数
 * @param val 入力後の文字列
 * @param maxLength 最大桁数
 * @returns
 */
export const formatIntegerString = (
  val: string,
  maxLength?: number,
): string | undefined => {
  if (val === "") {
    // 空白の場合は処理を挟まず返す
    return val;
  }

  if (!val.match(/^\d+$/)) {
    // 整数以外の場合は入力を無効化
    return;
  }

  if (maxLength !== undefined && val.length > maxLength) {
    // 最大値、最小値の範囲から外れる場合は入力を無効化
    return;
  }

  return val;
};
